import { LOCATION_AREA } from '../../routes';
import customAxios from "../../customAxios";
import {locationNamespace} from "../../../types/location.namespace";

async function updateArea(_id: string, props: locationNamespace.area.update) {
  try {
    return (await customAxios.patch(`${LOCATION_AREA}/${_id}`, props)).data;
  } catch (error: any) {
    console.error({LOCATION_AREA: error});
  }
}

export default updateArea;
